<template>
  <div class="content ht-100v pd-0">
    <!-- <form-edit
      :prms.sync="formEdit"
      :show.sync="formEdit.show"
      @on-attach="showFile($event)"
      @on-form-posted="formPosted"
      @on-edit-close="editClosed"
    ></form-edit>-->

    <!-- <mention-users
      :show="projectMention.show"
      :obj.sync="project"
      module="form"
      @on-mention-close="projectMention.show= false"
    ></mention-users>-->

    <form-detail
      v-if="formDialog.id > 0"
      :id.sync="formDialog.id"
      :flag.sync="ot"
      @on-edit="editShow($event)"
      @on-attach="showFile($event)"
      @on-reload="
        formDialog.id = 0;
        init();
      "
      @on-form-close="
        formDialog.id = 0;
        formLoaded();
      "
      @on-updated="formUpdated"
    ></form-detail>
    <!-- v-else -->
    <template>
      <div ref="mainHeader" class="content-header bd-b pd-0 bg-core-light">
        <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
          <div v-if="listSetting.mainMenu">
            <a
              class="order-1 navbar-brand tx-bold tx-spacing--2"
              role="button"
              >{{ formName }}</a
            >
            <!-- <div class="dropdown-menu tx-13">
              <a href="javascript:void(0)" class="dropdown-item">Загвар</a>
              <a @click="showMention()" href="javascript:void(0)" class="dropdown-item">Хуваалцах</a>
              <a
                @click="projectUsers()"
                href="javascript:void(0)"
                class="dropdown-item"
              >Эрхийн тохиргоо</a>
              <a href="javascript:void(0)" class="dropdown-item">Алхмын тохиргоо</a>
              <a href="javascript:void(0)" class="dropdown-item">Тохиргоо</a>
            </div>-->
          </div>
          <div v-else-if="listSetting.closeBtnShow">
            <a
              class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto"
              @click="$emit('on-close')"
            >
              <feather type="x"></feather>
            </a>
          </div>
          <a
            class="order-2 navbar-toggler"
            type="button"
            data-toggle="collapse"
            :data-target="`#navbarSupportedContent_1`"
            :aria-controls="`navbarSupportedContent_1`"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <feather type="menu" class="wd-20 ht-20"></feather>
          </a>
          <div
            class="order-2 collapse navbar-collapse"
            :id="`navbarSupportedContent_1`"
          >
            <div class="mg-l-auto">
              <template v-if="listSetting.chooser">
                <template v-if="checkedFormIds.length == 0">
                  <div
                    style="display: inline-block; padding: 6px 15px;"
                    class="alert alert-warning"
                    role="alert"
                  >
                    Холбох [{{ formName }}] - н урд байрлах
                    <feather type="square" stroke-width="1" size="14"></feather
                    >дараад холбох дарна уу!
                  </div>
                </template>
                <template v-else>
                  <a
                    class="text-white btn btn-sm pd-x-15 btn-success btn-uppercase mg-r-5"
                    @click="chooserCompleted"
                  >
                    <feather
                      type="link"
                      class="feather feather-chevron-down ht-15 pd-r-5"
                    ></feather
                    >холбох
                  </a>
                </template>
              </template>
              <a
                v-if="listSetting.newBtnShow"
                class="text-white btn btn-sm pd-x-15 btn-primary btn-uppercase"
                @click="editShow(0)"
              >
                <feather type="plus" class="m-r-5"></feather>Шинэ
              </a>
              <a
                v-if="listSetting.closeBtnShow"
                @click="forceClose"
                class="text-white btn btn-sm pd-x-15 btn-uppercase mg-l-5 btn-danger"
              >
                <feather type="x" class="m-r-5"></feather>Хаах
              </a>
            </div>
          </div>
        </nav>
      </div>
      <div class="overflow-hidden content-body pd-x-0 pd-y-0">
        <div class="container-fluid pd-x-0" id="cstmScrll">
          <div class="row no-gutters">
            <div class="col-xs-2 col-md-2 bg-core-light">
              <div
                v-if="listSetting.statisticLoad"
                class="pd-x-10"
                ref="sideTop"
              ></div>
              <!-- <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 p-l-sm">
                Төрөл
                <a role="button"
                  title="Төрөл үүсгэх"
                  style="float: right;"
                  class="p-r-sm"
                  @click="addTag('formType')"
                >
                  <feather type="plus"></feather>
                </a>
              </label>-->
              <div class="bg-white pd-10">
                <button
                  class="btn btn-outline-light btn-xs btn-block"
                  @click="addTag('formType')"
                >
                  <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Төрөл
                  үүсгэх
                </button>
              </div>
              <vue-custom-scrollbar
                :style="`height:${scrSideHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
                class="bd-t"
              >
                <nav class="nav nav-sidebar tx-13 pd-x-5 pd-t-10">
                  <a
                    v-for="(t, i) in types"
                    role="button"
                    :key="`fltrType_${i}`"
                    class="nav-link"
                    :class="{ active: searchModel.locTypeId == t.id }"
                    @click="filterList(t.id)"
                  >
                    <feather type="folder"></feather>
                    <div>
                      <span>{{ t.s1 }}</span>
                    </div>
                    <span
                      v-show="searchModel.locTypeId == t.id"
                      class="text-white badge"
                    >
                      <feather type="x" style="color: red;"></feather>
                    </span>
                  </a>
                </nav>
              </vue-custom-scrollbar>
              <div class="text-center d-none d-md-block bd-t" ref="sideBtm">
                <div
                  class="btn-group mg-y-7"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    @click="init(true)"
                    type="button"
                    class="btn btn-xs btn-light"
                  >
                    <feather type="refresh-ccw" class="mg-r-5"></feather>
                    <span>Бүгд</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-xs-10 col-md-10 bd-l">
              <div
                ref="listHeader"
                class="row no-gutters bg-list-header"
                v-show="formsCount > 0"
              >
                <div class="text-center wd-5p tx-10 align-items-center d-flex">
                  #
                </div>
                <div
                  :class="
                    `tx-10 align-items-center d-flex pd-y-7 text-black bd-l text-uppercase lh-1`
                  "
                  :style="`width: ${f.span}%`"
                  v-for="(f, i) in fields"
                  :key="i"
                >
                  {{ f.title }}
                </div>
              </div>

              <vue-custom-scrollbar
                :style="`height:${scrHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
              >
                <div v-if="!loading" class="d-list">
                  <div v-if="formsCount == 0" class>
                    <div class>
                      <div
                        class="ht-700 d-flex flex-column align-items-center justify-content-center"
                      >
                        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                          <img
                            src="assets/img/img22.png"
                            class="img-fluid"
                            alt
                          />
                        </div>
                        <p class="tx-color-03 mg-b-30">
                          Жагсаалт хоосон байна.
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- @click.prevent.stop="handleClick($event, f)" -->
                  <div v-else v-for="(f, i) in forms" :key="i" class="d-row">
                    <!-- <div v-show="isDrawGroupDateRange(i)" class="row no-gutters core-list-group">
                      <div class="col-12 text-muted">
                        <span class="pd-l-10 tx-12 tx-lowercase">{{f[showGroupLabel()]}}</span>
                      </div>
                    </div>-->
                    <div
                      role="button"
                      @click="showDetail(f)"
                      class="row highlight no-gutters list-row"
                    >
                      <div
                        class="wd-5p no-gutters align-items-center d-flex justify-content-end"
                      >
                        <div class="pr-1 text-right text-muted tx-11">
                          {{ (pager.current - 1) * pager.perPage + i + 1 }}
                        </div>
                        <div class="pt-1 text-center wd-25 bd-l" @click.stop>
                          <input
                            @click.stop
                            @change="formChecked(f.id)"
                            type="checkbox"
                            role="button"
                          />
                        </div>
                      </div>
                      <div
                        :style="`width: 45%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">{{ f.title }}</div>
                      </div>
                      <div
                        :style="`width: 10%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">
                          {{ f.questionData.count }}
                        </div>
                      </div>
                      <div
                        :style="`width: 20%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">
                          {{ f.startDate | moment("YYYY/MM/DD HH:mm") }}
                        </div>
                      </div>
                      <div
                        :style="`width: 20%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">
                          {{ f.endDate | moment("YYYY/MM/DD HH:mm") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else></div>
              </vue-custom-scrollbar>

              <div
                ref="listFooter"
                class="py-2 d-flex justify-content-between bd-t bg-core-light"
                v-show="formsCount > 0"
              >
                <div class="pd-x-5 pd-t-5 text-muted tx-12">
                  Нийт:
                  <span class="font-weight-bold">{{ formsCount }}</span> бичилт.
                  Харагдаж буй:
                  <span class="font-weight-bold">{{
                    (pager.current - 1) * pager.perPage + 1
                  }}</span>
                  -
                  <span class="font-weight-bold">{{
                    (pager.current - 1) * pager.perPage + forms.length
                  }}</span>
                </div>
                <div>
                  <b-pagination
                    size="sm"
                    align="center"
                    v-model="pager.current"
                    :total-rows="formsCount"
                    :per-page="pager.perPage"
                    @change="pageChanged"
                    style="margin-bottom: 0"
                  ></b-pagination>
                </div>
                <div>
                  <a @click="init(true)" role="button">
                    <feather
                      type="refresh-cw"
                      class="wd-20 ht-20 text-muted mg-r-10 mg-t-5"
                    ></feather>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal
      v-model="formModal"
      @hide="cancelForm"
      scrollable
      :title="formName+' үүсгэх / засах'"
      centered
      size="lg"
      body-class="pd-0"
    >
      <!-- <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          role="button"
          class="close pos-absolute t-15 r-15"
          @click="cancelForm"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </a>

        <div class="media align-items-center">
          <div class="tx-color-03 d-none d-sm-block">
            <feather type="edit" class="wd-40-f ht-40-f"></feather>
          </div>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">{{ formName }} үүсгэх / засах</h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              Тохирох утгуудыг бөглөөд хадгалах дарна уу
            </p>
          </div>
        </div>
      </div> -->
      <div v-if="formModal" class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
        <Form :model="formModel" label-position="right" label-width="250px">
          <FormItem
            label="Шалгалт ERP"
            v-if="
              ($store.state.app.activeGroup.id == 9241 ||
                $store.state.app.activeGroup.id == 9249) &&
                (ot == 500 || ot == 900)
            "
          >
            <Select
              v-model="formModel.integrationCode"
              style="width:100%"
              @change="erpExamChanged"
            >
              <Option
                v-for="(t, i) in erpExams"
                :label="t.examName"
                :value="t.examId"
                :key="i"
              ></Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="Шалгалт ID">
            <Input v-model="formModel.integrationCode" type="text" />
          </FormItem> -->
          <FormItem label="Төрөл">
            <div class="d-flex">
              <div class="wd-80p">
                <Select v-model="formModel.locTypeId" style="width:100%">
                  <Option
                    v-for="(t, i) in types"
                    :label="t.s1"
                    :value="t.id"
                    :key="i"
                    >{{ t.s1 }}</Option
                  >
                </Select>
              </div>
              <div class="wd-20p mg-l-5">
                <button
                  class="btn btn-outline-light"
                  @click="addTag('formType')"
                  type="button"
                >
                  <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i>
                </button>
              </div>
            </div>
          </FormItem>
          <FormItem label="Гарчиг">
            <!-- <Input v-model="formModel.name" placeholder="Гарчиг" type="text" /> -->
            <div class="el-input">
              <input v-model="formModel.name" placeholder="Гарчиг" type="text"  class="el-input__inner" />
            </div>
          </FormItem>
          <FormItem v-if="ot == 900" label="Шалгалтын нууц үг">
            <Input
              v-model="formModel.password"
              placeholder="Шалгалтын нууц үг"
              type="text"
            />
          </FormItem>
          <FormItem v-else label="Тайлбар">
            <!-- v-if="ot==600" -->
            <summernote
              v-model="formModel.info"
              :text="formModel.info"
              :key="editorKey"
              class="m-t-sm m-b-sm"
            ></summernote>
            <!-- <Input v-else v-model="formModel.description" placeholder="Тайлбар" type="text" /> -->
          </FormItem>
          <FormItem label="Эхлэх" v-if="ot == 900 || ot == 600">
            <!-- <DatePicker
              :value="formModel.startDate"
              @on-change="(value) => formModel.startDate = value.toLocaleString()"
              placeholder="Эхлэх"
              type="datetime"
              style="width: 40%"
            ></DatePicker>-->
            <!-- <DatePicker
              v-model="formModel.startDate"
              placeholder="Огноо сонгоно уу"
              type="datetime"
              style="width: 100%"
              :format="'yyyy-MM-dd HH:mm:ss'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
            ></DatePicker> -->
            <VueCtkDateTimePicker locale="mn" :minute-interval="5" v-model="formModel.startDate" no-label format="YYYY-MM-DD HH:mm" />
          </FormItem>
          <FormItem
            label="Дуусах"
            v-if="
              ot == 900 ||
                ot == 600 ||
                (ot == 700 && $store.state.app.activeGroup.id == 6126)
            "
          >
            <!-- <DatePicker
              :value="formModel.endDate"
              @on-change="(value) => formModel.endDate = value.toLocaleString()"
              placeholder="Дуусах"
              type="datetime"
              style="width: 40%"
            ></DatePicker>-->
            <!-- <DatePicker
              v-model="formModel.endDate"
              placeholder="Огноо сонгоно уу"
              type="datetime"
              style="width: 100%"
              :format="'yyyy-MM-dd HH:mm:ss'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
            ></DatePicker> -->
            <VueCtkDateTimePicker locale="mn" :minute-interval="5" v-model="formModel.endDate" no-label format="YYYY-MM-DD HH:mm" />
          </FormItem>
          <FormItem label="Асуултын харагдац" v-if="ot == 900 || ot == 500">
            <Select v-model="formModel.viewType">
              <Option :value="0" :key="0" label="Бүх асуулт нэг хуудсанд">Бүх асуулт нэг хуудсанд</Option>
              <Option :value="1" :key="1" label="Бүлгээр хуудаслалт үүсгэж харуулах">Бүлгээр хуудаслалт үүсгэж харуулах</Option>
            </Select>
            <!-- <div class="text-muted tx-11 eddt-title-info">
              Үгүй гэсэн тохиолдолд асуултын сангийн дарааллаар асуулт үүснэ.
            </div> -->
          </FormItem>
          <FormItem label="Асуултыг холих эсэх" v-if="ot == 900 || ot == 500">
            <Select v-model="formModel.questionShuffle">
              <Option :value="1" :key="1" label="Тийм">Тийм</Option>
              <Option :value="-1" :key="-1" label="Үгүй">Үгүй</Option>
            </Select>
            <div class="text-muted tx-11 eddt-title-info">
              Үгүй гэсэн тохиолдолд асуултын сангийн дарааллаар асуулт үүснэ.
            </div>
          </FormItem>

          <FormItem label="Хариултыг холих эсэх" v-if="ot == 900 || ot == 500">
            <Select v-model="formModel.answerShuffle">
              <Option :value="1" :key="1" label="Тийм">Тийм</Option>
              <Option :value="0" :key="0" label="Үгүй">Үгүй</Option>
            </Select>
            <div class="text-muted tx-11 eddt-title-info">
              Үгүй гэсэн тохиолдолд сангийн дарааллаар хариулт харагдана.
            </div>
          </FormItem>

          <FormItem label="Шалгалтын систем хувилбар 5.0" v-if="(ot == 900 || ot == 500)&& ($store.state.user.userInfo.groupId == 9157 ||
          $store.state.user.userInfo.groupId == 1104 || $store.state.user.userInfo.groupId == 9256 || $store.state.user.userInfo.groupId == 9352
          )">
            <Select v-model="formModel.isRegisterRequired">
              <Option :value="true" :key="true" label="Тийм">Тийм</Option>
              <Option :value="false" :key="false" label="Үгүй">Үгүй</Option>
            </Select>
          </FormItem>
          <FormItem label="Шалгалтын бүлэг алгасах боломж ?" v-if="(ot == 900 || ot == 500) && ($store.state.user.userInfo.groupId == 9157 ||
          $store.state.user.userInfo.groupId == 1104
          ) && formModel.isRegisterRequired">
            <Select v-model="formModel.onFinishEvent">
              <Option :value="0" :key="0" label="Үгүй">Үгүй</Option>
              <Option :value="1" :key="1" label="Тийм">Тийм</Option>
            </Select>
          </FormItem>

          <FormItem label="Боломжит оролдлого" v-if="ot == 500">
            <Select v-model="formModel.attemptCount" style="width: 150px">
              <Option v-for="(a, i) in 101" :value="a-1" :key="i-1">{{ a-1 }}</Option>
            </Select>
            <div class="text-muted p-l-sm tx-11 eddt-title-info"
              >Бататгах шалгалтыг хамгийн ихдээ хэдэн удаа дахин бөглөх боломжит
              оролдлогын тоо</div
            >
          </FormItem>

          <FormItem label="Үргэлжлэх хугацаа" v-if="ot == 500">
            <InputNumber
              @change="setLessonExamRange($event)"
              v-model="formModel.minute"
              :value="20"
            ></InputNumber>
            <span class="text-muted p-l-sm">(минутаар)</span>
          </FormItem>
          <template
            v-if="hasPermission(['formimporter']) && (ot == 800 || ot == 700)"
          >
            <FormItem label="Файлаас тест үүсгэх">
              <simple-uploader
                :propBoxId="0"
                :propObjectId="'0'"
                :propObjectTypeId="6"
                @on-success="fileUploaded($event)"
                style="width:100%;"
              >
                <div slot="trigger" class="wd-100p">
                  <span v-if="formModel.fileId == 0">файлаас импорт хийх</span>
                  <span v-else>{{ formModel.fileName }}</span>
                </div>
              </simple-uploader>
            </FormItem>
          </template>
          <FormItem
            label="Системийн бус хэрэглэгч бөглөх ?"
            v-if="ot == 700 || ot == 600"
          >
            <Select v-model="formModel.isAnonymous">
              <Option :value="1" :key="1" label="Тийм">Тийм</Option>
              <Option :value="0" :key="0" label="Үгүй">Үгүй</Option>
            </Select>
          </FormItem>
          <FormItem
            label="EQ шалгалт эсэх ?"
            v-if="ot == 500 && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)"
          >
            <Select v-model="formModel.isAnonymous">
              <Option :value="1" :key="1" label="Тийм">Тийм</Option>
              <Option :value="0" :key="0" label="Үгүй">Үгүй</Option>
            </Select>
          </FormItem>
          <FormItem label="Хариултын харагдац" v-if="ot == 700">
            <Select v-model="formModel.questionShuffle">
              <Option :value="-1" :key="-1" label="Жагсаалтаар"></Option>
              <Option :value="1" :key="1" label="Хүснэгтээр"></Option>
            </Select>
            <div class="text-muted tx-11 eddt-title-info lh-1 mg-t-10">
              Жагсаалтаар сонголт нь хариулт тус бүр шинэ мөрөнд харагдана. Хүснэгтээр сонголт нь хариулт тус бүр баганан хэлбэрээр харагдана
            </div>
          </FormItem>

          <FormItem label="Хүлээлгийн горим цаг тоолох ?" v-if="ot == 600">
            <Select v-model="formModel.timeLimit">
              <Option :value="0" :key="0" label="Тийм">Тийм</Option>
              <Option :value="1" :key="1" label="Үгүй">Үгүй</Option>
            </Select>
          </FormItem>
          <FormItem label="Үр дүнд хэрэглэгч нууцлах ?" v-if="ot == 600">
            <Select v-model="formModel.onFinishEvent">
              <Option :value="0" :key="0" label="Үгүй">Үгүй</Option>
              <Option :value="1" :key="1" label="Тийм">Тийм</Option>
            </Select>
          </FormItem>
          <FormItem label="Хэрхэн бөглөснийг харуулах ?" v-if="ot == 500">
            <Select v-model="formModel.ord" class="wd-100p">
              <Option :value="0" label="Үгүй">Үгүй</Option>
              <Option :value="1" label="Тийм - Зөв хариултыг харуулна"
                >Тийм (Зөв хариултыг харуулна)</Option
              >
              <Option :value="2" label="Тийм - Зөв хариултыг харуулахгүй"
                >Тийм (Зөв хариултыг харуулахгүй)</Option
              >
            </Select>
          </FormItem>
        </Form>
      </div>

      <template #modal-footer>
        <div>
          <!-- <button type="button" class="btn btn-white" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary">Save Info</button>-->
          <button type="button" class="btn btn-white mg-r-10" @click="cancelForm">
            Болих
          </button>
          <button @click="postForm()" class="btn btn-primary">Хадгалах</button>
        </div>
      </template>
    </b-modal>
    <tag-modal
      :shw="addTagConfig.modal"
      :lkey="addTagConfig.key"
      :flag="ot == 600 ? ot : null"
      @on-load="getTypeData()"
      @on-close="addTagConfig.modal = false"
    ></tag-modal>

    <file-dialog
      :show.sync="fileDialog.show"
      :id.sync="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";
import { mapActions } from "vuex";
import { hasOneOf, formatDateYMDHM } from "@/libs/tools";
const moment = require("moment");
import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  Input,
  FormItem,
  DatePicker,
  //Divider,
  InputNumber,
  Select,
  //OptionGroup,
  Option,
  Notification
  //Checkbox,
  //RadioGroup,
  //Radio
} from "element-ui";

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
  components: {
    VueCtkDateTimePicker,
    Form,
    FormItem,
    Input,
    DatePicker,
    InputNumber,
    Select,
    Option,
    vueCustomScrollbar,
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formDetail: () => ({
      component: import("@/components/form/detail/formDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    tagModal: () => ({
      component: import("@/components/modules/tag"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 5000
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    formName: "",
    forceLoad: false,
    ot: -1,
    mode: 0,
    fetched: false,
    loading: false,
    listSetting: {
      newBtnShow: true,
      statisticLoad: true,
      closeBtnShow: false,
      mainMenu: true,
      chooser: false
    },
    fileDialog: {
      show: false,
      id: 0
    },
    formsCount: 0,
    pager: {
      perPage: 50,
      current: 1
    },
    editorKey: 0,
    types: [],
    formModal: false,
    formModel: {
      id: 0,
      name: "",
      startDate: null,
      endDate: null,
      locTypeId: null,
      password: "",
      description: "",
      info: "",
      attemptCount: 1,
      minute: 20,
      fileId: 0,
      fileName: "",
      isAnonymous: 0,
      timeLimit: 0,
      onFinishEvent: null,
      ord: 0,
      integrationCode: null,
      questionShuffle: null,
      viewType: null,
      isRegisterRequired: null,
    },
    erpExams: [],

    formDialog: {
      show: false,
      id: 0,
      key: 0
    },
    scrHeight: 600,
    scrSideHeight: 600,
    checkedFormIds: [],
    forms: [],
    fields: [
      {
        title: "Гарчиг",
        span: 45
      },
      {
        title: "Асуултын тоо",
        span: 10
      },
      {
        title: "Эхлэх",
        span: 20
      },
      {
        title: "Дуусах",
        span: 20
      }
    ],
    searchModel: {
      title: "",
      locTypeId: 0,
      flag: 0,
      page: 0,
      size: 40,
      endDate: null
    },
    routeConfig: {
      edit: 0,
      detail: 0
    },
    addTagConfig: { modal: false, key: "" }
  }),
  props: {
    prms: {
      type: Object,
      default: () => {}
    }
  },
  beforeDestroy() {
    this.tasks = [];
    this.fields = [];
    window.removeEventListener("resize", this.getWindowHeight);
  },
  mounted() {
    if (this.prms != undefined && this.prms.objectTypeId != undefined) {
      //console.log('mounted 01');
      this.forceLoad = true;
      this.mode = this.prms.mode;

      if (this.mode == 50) {
        this.listSetting.mainMenu = false;
        this.listSetting.closeBtnShow = true;
        this.listSetting.statisticLoad = false;
        this.listSetting.chooser = true;
      } else if (this.mode == 51) {
        this.listSetting.newBtnShow = false;
        this.listSetting.mainMenu = false;
        this.listSetting.closeBtnShow = true;
        this.listSetting.statisticLoad = false;
        this.listSetting.chooser = true;
      } else if (this.mode == -100) {
        this.listSetting.newBtnShow = false;
        this.listSetting.mainMenu = false;
        this.listSetting.closeBtnShow = true;
        this.listSetting.statisticLoad = false;
        this.listSetting.chooser = true;
      }

      this.$nextTick(() => {
        this.build(this.prms.objectTypeId, 0, 0);
      });
    } else {
      //console.log('mounted 02');
      this.forceLoad = true;
      this.$nextTick(() => {
        this.build(
          parseInt(this.$route.params.ot, 10),
          this.$route.params.edit,
          this.$route.params.detail
        );
      });
    }
  },
  methods: {
    ...mapActions(["handleLoading", "handleAside", "handleUserInfoModal"]),
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    formUpdated(e) {
      let frm = this.forms.filter(x => x.id == e.id);
      if (frm.length > 0) frm[0].questionData.count = e.count;
    },
    getWindowHeight() {
      if (this.formDialog.id == 0) {
        let extras =
          this.$refs.mainHeader.offsetHeight +
          this.$refs.listHeader.offsetHeight +
          this.$refs.listFooter.offsetHeight;
        let extraSide =
          this.$refs.mainHeader.offsetHeight +
          (this.listSetting.statisticLoad
            ? this.$refs.sideTop.offsetHeight
            : 0) +
          this.$refs.sideBtm.offsetHeight;

        this.scrHeight = window.innerHeight - extras;
        this.scrSideHeight = window.innerHeight - extraSide;
      }
    },
    build(ot, edit, detail) {
      this.ot = ot;
      this.routeConfig.edit = edit;
      this.routeConfig.detail = detail;
      if (this.ot == 700) this.formName = "Судалгаа";
      else if (this.ot == 800) this.formName = "Тестийн сан";
      else if (this.ot == 600) this.formName = "Санал асуулга";
      else if (this.ot == 900) this.formName = "Шалгалт";
      else if (this.ot == 500) this.formName = "Явцын шалгалт";

      this.handleLoading({ isLoading: true });
      window.addEventListener("resize", this.getWindowHeight);
      this.init();
    },
    init(force) {
      if (force) {
        this.searchModel.title = "";
        this.searchModel.page = 0;
        this.searchModel.locTypeId = 0;
      }
      if (this.listSetting.chooser == true && this.ot == 900) {
        request({
          api: { method: "GET", url: "servertime" },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.searchModel.endDate = res.data.now;
            this.fetchData();
          } else {
            this.fetchData();
          }
        });
      } else {
        this.fetchData();
      }
    },
    fetchData() {
      request({
        api: { method: "GET", url: "form/formList" },
        params: {
          flag: this.ot,
          title: this.searchModel.title,
          locTypeId: this.searchModel.locTypeId,
          page: this.pager.current - 1,
          size: this.pager.perPage,
          endDate: this.searchModel.endDate
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.formsCount = res.data.count;
          this.forms = res.data.forms;
          this.getTypeData();
        }
      });
    },
    addTag(key) {
      this.addTagConfig.key = key;
      this.addTagConfig.modal = true;
    },
    //handleClick(event, item) {
    //console.log(event, item);
    //   if(this.forceLoad)
    //     this.$refs.vueSimpleContextMenu.showMenu(event, item);
    //},
    taskLoaded() {
      //console.log("taskLoaded", e);
      this.handleLoading({ isLoading: false });
      this.formDialog.show = true;
    },
    formChecked(id) {
      const index = this.checkedFormIds.indexOf(id);
      if (index > -1) {
        this.checkedFormIds.splice(index, 1);
      } else {
        this.checkedFormIds.push(id);
      }
    },
    setLessonExamRange(e) {
      if (this.formModel.startDate != null) {
        this.formModel.endDate = formatDateYMDHM(
          moment(this.formModel.startDate).add(e, "minutes")
        );
      } else {
        this.formModel.endDate = formatDateYMDHM(
          moment(new Date()).add(e, "minutes")
        );
      }
    },
    chooserCompleted() {
      //console.log(this.checkedFormIds);
      this.$emit("on-form-selected", this.checkedFormIds);
      this.dispose();
    },
    forceClose() {
      this.$emit("on-close");
    },
    showFile(e) {
      this.fileDialog.id = e.id;
      this.fileDialog.show = true;
    },
    onFormDelete() {},
    showDetail(e) {
      //console.log(e);
      if (!this.$store.state.app.aside.minimize)
        this.handleAside({ minimize: true, maximize: false });
      //console.log(e, e.mode);
      //console.log(t, mode);
      if (this.listSetting.chooser) {
        // this.dispose();
        // this.$nextTick(() => {
        //   this.$emit("on-form-selected", e);
        // });

        this.formDialog.id = 0;
        this.$nextTick(function() {
          this.handleLoading({ isLoading: true });
          this.formDialog.id = e.id;
        });
      } else if (e.mode != undefined && e.mode == 80) {
        //this.taskDialogSide.id = e.obj.id;
        //console.log('onDrawer neenee');
      } else {
        this.formDialog.id = 0;
        this.$nextTick(function() {
          this.handleLoading({ isLoading: true });
          this.formDialog.id = e.id;
        });
      }
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    formLoaded() {},
    dispose() {
      Object.assign(this.$data, this.$options.data());
      window.removeEventListener("resize", this.getWindowHeight);
    },
    fileUploaded(e, field) {
      //console.log(e, field);
      //task.uv = false;

      this.formModel.fileId = e.uploadedAttachmentId;
      this.formModel.fileName = e.uploadedName;

      // this.formModel.fileId = e.response.data.uploadedAttachmentId;
      // this.formModel.fileName = e.response.data.uploadedName;
    },
    editShow(e) {
      if (
        //this.$store.state.app.activeGroup.id==9241 ||
        this.$store.state.app.activeGroup.id == 9249 &&
        (this.ot == 500 || this.ot == 900)
      ) {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "get", url: "open/learn/examList" },
          store: this.$store
        }).then(res => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            //console.log('open/learn/examList', res.data.list);
            this.erpExams = res.data.list;
          }
        });
      }

      if (e == 0) {
        //console.log('ene ajillaj bnu 01');
        this.formModel.id = 0;
        this.formModel.fileId = 0;
        this.formModel.viewType = 0;
      } else {
        // console.log('ene ajillaj bnu 02', e);
        this.formDialog.id = 0;
        this.formModel.fileId = 0;
        this.formModel.id = e.id;
        this.formModel.name = e.title;
        this.formModel.locTypeId = e.locType.id;
        this.formModel.description = e.description;
        this.formModel.info = e.info;
        this.formModel.password = e.info;
        this.formModel.startDate = moment(e.startDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formModel.endDate = moment(e.endDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formModel.attemptCount = e.attemptCount;
        this.formModel.minute = e.minute;
        this.formModel.questionShuffle = e.questionShuffle;
        this.formModel.answerShuffle = e.answerShuffle;
        this.formModel.isAnonymous = e.isAnonymous ? 1 : 0;
        this.formModel.timeLimit = e.timeLimit ? 1 : 0;
        this.formModel.onFinishEvent = e.onFinishEvent ? 1 : 0;
        //console.log('e.ord', e.ord);
        //this.formModel.ord = e.ord ? 1 : 0;
        this.formModel.ord = e.ord;
        this.formModel.integrationCode = e.integrationCode;
        this.formModel.isRegisterRequired = e.isRegisterRequired;
        this.formModel.viewType = e.viewType;
      }
      this.editorKey++;
      //console.log(e.attemptCount);
      this.$nextTick(() => {
        this.formModal = true;
      });
    },
    getTypeData() {
      request({
        api: { method: "get", url: "Type/GetData" },
        params: {
          key: "formType",
          getParentType: false
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          if (this.ot == 600) {
            this.types = res.data.types.filter(x => x.field1 == this.ot);
          } else {
            this.types = res.data.types;
          }
          if (this.routeConfig.edit == 1) {
            this.editShow(0);
            this.routeConfig.edit = 0;
          }
          this.getWindowHeight();
        }
      });
    },
    filterList(id) {
      this.searchModel.page = 0;
      if (this.searchModel.locTypeId == id) {
        this.searchModel.locTypeId = 0;
        this.init();
      } else {
        this.searchModel.locTypeId = id;
        this.init();
      }
    },
    postForm() {
      let errs = [];
      if (this.formModel.name == "") {
        errs.push("Гарчиг оруулна уу !");
      }

      if (errs.length == 0) {
        this.formModel.flag = this.ot;
        request({
          api: { method: "POST", url: "Form/PostForm" },
          data: this.formModel,
          store: this.$store
        }).then(res => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            this.cancelForm();
            this.formModal = false;
            this.init();
          }
        });
      } else {
        Notification.error({
          message: errs[0],
          duration: 5000,
          type: "error",
          position: "top-right",
          offset: 50
        });
        // this.$Notice.error({
        //   title: "Алдаа гарлаа",
        //   desc: errs[0]
        // });
      }
    },
    cancelForm() {
      this.formModel = {
        id: 0,
        name: "",
        startDate: null,
        endDate: null,
        locTypeId: null,
        password: "",
        description: "",
        info: "",
        fileId: 0,
        fileName: "",
        isAnonymous: 0,
        timeLimit: 0,
        onFinishEvent: null,
        ord: 0,
        integrationCode: null
      };
      this.formModal = false;
      this.editorKey++;
    },
    erpExamChanged(e) {
      let _c = this.erpExams.filter(x => x.examId == e);
      if (_c.length > 0) {
        this.formModel.name = _c[0].examName;
        //this.formModel.integrationCode=_c[0].examId;
      }
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      this.dispose();
      this.$nextTick(() => {
        this.forceLoad = true;
        this.$nextTick(() => {
          this.build(
            parseInt(this.$route.params.ot, 10),
            this.$route.params.edit,
            this.$route.params.detail
          );
        });
      });
    }
  }
};
</script>
